<div class="w-[30vw] h-[20vh]">
  <div class="flex justify-center items-center">
    <div>
      <i class="material-symbols-outlined !text-9xl text-red-600">error</i>
    </div>
    @if(routingData.documentType=="Document") {
    <div>{{ 'DeleteDocument.WarningText'|translate:routingData.filename }}</div>
    }
    @else if(routingData.documentType=="Image"){
      <div>{{ 'DeleteImage.WarningText'|translate:routingData.filename }}</div>
    }
  </div>
  <div class="flex justify-around items-center mt-[3vh]">
    <p-button label="{{'Yes'|translate}}" (click)="deleteDocument()"/>
    <p-button label="{{'No'|translate}}" (click)="abort()"/>
  </div>
</div>
